import { RoutePaths } from '../../../routes/history';
const BASE_URL = window.origin;

export const redirectURI = (partnerId: string) =>
  `${BASE_URL}${RoutePaths.CallbackView(partnerId)}`;
